// init
import $ from 'jquery'
import platform from 'platform'

if (platform.name === 'Safari') {
  $('body').css('font-feature-settings', 'normal')

  // back forward cache
  window.onpageshow = function (e) {
    if (e.persisted) {
      window.location.reload()
    }
  }
}

// top banner
let interval = 4500
$('.p-top__banner ul li:first-child').addClass('is-active')
setInterval(() => {
  let $active = $('.p-top__banner ul li.is-active')
  let $next = $active.next('li').length ? $active.next('li') : $('.p-top__banner ul li:first-child')
  $active.removeClass('is-active')
  $next.addClass('is-active')
}, interval)

// Add Current Navigation Class Based on URL
if (location.pathname !== '/recruit/pgp.html') {
  let pathName = location.pathname.split('/')
  pathName = pathName.filter(function (element, index, array) {
    return (element !== '')
  })
  let URL = '/'
  let naviLink = ''
  pathName.forEach(function (val, index, array) {
    URL += `${val}/`
    naviLink += `.nav a[href="${URL}"], .nav-child a[href="${URL}"], .menu__nav-child a[href="${URL}"], `
  })
  naviLink += `.nav a[href="${location.pathname}"], .menu__nav a[href="${location.pathname}"], .menu__footer a[href="${location.pathname}"], .footer-nav a[href="${location.pathname}"]`
  $(naviLink).parent('li').addClass('is-current')
  if ($(naviLink).next('.nav-child').length === 0) {
    $(naviLink).parent('li').addClass('no-child')
  }
}

// caliculate navi height
let navHeight = $('.is-current .nav-child').outerHeight(true)
$('.header').css('margin-bottom', navHeight + 'px')

// toggle menu
let $toggle = $('.menu-button, .menu:not("li")')
let isOpenMenu = false
$toggle.on('click', () => {
  isOpenMenu = !isOpenMenu
  $('.header').toggleClass('open')
  $toggle.attr({'aria-expanded': isOpenMenu})
})

// hover for touch
$(function () {
  $(document).on({
    'mouseenter touchstart': function () {
      $(this).addClass('hover')
    },
    'mouseleave touchend': function () {
      $(this).removeClass('hover')
    }
  }, '.c-link')
})



// WEBPACK FOOTER //
// ./src/assets/js/base.js